import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=c1650bd2&scoped=true"
import script from "./user-manage.vue?vue&type=script&lang=ts"
export * from "./user-manage.vue?vue&type=script&lang=ts"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=c1650bd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1650bd2",
  null
  
)

export default component.exports